import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getDashboardCount, getDashboardOrderList } from "./dashboard.service";
import { IDashboardState, IDashboardFilter } from "./dashboardModel";
import dayjs from "dayjs";

const initialState: IDashboardState = {
  loading: false,
  error: "",
  dashboardData: null,
  filter: {
    FromDate: dayjs().format("YYYY-MM-DD"),
    ToDate: dayjs().format("YYYY-MM-DD"),
  },
  filterType: "Today",
  dashboardOrders: [],
  dashboardTotalCount: 0,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<{ type: "Today" | "This Week" | "This Month" | "Custom", filter?: IDashboardFilter }>) => {
      state.filterType = action.payload.type;
      if (action.payload.filter) {
        state.filter = action.payload.filter;
      } else {
        const today = dayjs().format("YYYY-MM-DD");
        switch (action.payload.type) {
          case "Today":
            state.filter = { FromDate: today, ToDate: today };
            break;
          case "This Week":
            state.filter = {
              FromDate: dayjs().startOf("week").format("YYYY-MM-DD"),
              ToDate: dayjs().endOf("week").format("YYYY-MM-DD"),
            };
            break;
          case "This Month":
            state.filter = {
              FromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
              ToDate: dayjs().endOf("month").format("YYYY-MM-DD"),
            };
            break;
        }
      }
    },
  },
  extraReducers: (builder) => {
    // Dashboard Count
    builder.addCase(getDashboardCount.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getDashboardCount.fulfilled, (state, action) => {
      state.loading = false;
      state.dashboardData = action.payload?.Data || null;
    });
    builder.addCase(getDashboardCount.rejected, (state, action: any) => {
      state.loading = false;
      state.error = action.error?.message || "Something went wrong";
    });

    // Dashboard Order List
    builder.addCase(getDashboardOrderList.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getDashboardOrderList.fulfilled, (state, action) => {
      state.loading = false;
      state.dashboardOrders = action.payload?.Data || [];
      state.dashboardTotalCount = action.payload?.ItemCount || 0;
    });
    builder.addCase(getDashboardOrderList.rejected, (state, action: any) => {
      state.loading = false;
      state.error = action.error?.message || "Something went wrong";
    });
  },
});

export const { setFilter } = dashboardSlice.actions;
export default dashboardSlice.reducer;
